import {Component, HostBinding, Input} from '@angular/core';
import {timestampToDateTime} from '../../../../utility/timestamp-functions';
import {CommentModel} from '../end-user-order-payment-item/end-user-order-custom-payment.model';

@Component({
  selector: 'app-end-user-order-debt-penalty-comment',
  templateUrl: './end-user-order-debt-penalty-comment.component.html',
})
export class EndUserOrderDebtPenaltyCommentComponent {
  protected readonly timestampToDateTime = timestampToDateTime;
  @HostBinding('class.profile-description-item') descriptionItem = true;
  @Input() commentModel: CommentModel;

  constructor() {
  }

}
